<template>
  <van-grid clickable :column-num="2">
    <van-grid-item>
      <span>证件种类：{{ formData.speciesNameTemp }}</span>
    </van-grid-item>
    <van-grid-item>
      <span>作业类别：{{ formData.projectNameTemp }}</span>
    </van-grid-item>
    <van-grid-item>
      <span>准操项目：{{ formData.courseNameTemp }}</span>
    </van-grid-item>
    <van-grid-item>
      {{ formData.chooseType }}
    </van-grid-item>
    <van-grid-item>
      <span>性别：{{ formData.sex }}</span>
    </van-grid-item>
    <van-grid-item>
      <span>学历：{{ formData.education }}</span>
    </van-grid-item>
    <van-grid-item>
      <span>单位：{{ formData.dept }}</span>
    </van-grid-item>
    <van-grid-item>
      <span>手机号：{{ formData.phone }}</span>
    </van-grid-item>
    <van-grid-item>
      <span>身份证号：{{ formData.cardNumber }}</span>
    </van-grid-item>
  </van-grid>
  <van-grid
      class="minute-end"
      :center="false"
      clickable
      :column-num="1"
      direction="horizontal"
  >
    <van-grid-item>
      <span style="width: 100px">身份证：</span>
      <van-image
          width="100"
          height="80"
          :src="cardUpload.cardPositive[0].content"
      />
      <van-image
          style="padding-left: 10px"
          width="100"
          height="80"
          :src="cardUpload.cardNegative[0].content"
      />
    </van-grid-item>
    <van-grid-item v-if="formData.chooseType === '复训'">
      <span style="width: 100px">复训证：</span>
      <van-image
          width="100"
          height="80"
          :src="cardUpload.retrainPositive[0].content"
      />
      <van-image
          style="padding-left: 10px"
          width="100"
          height="80"
          :src="cardUpload.retrainNegative[0].content"
      />
    </van-grid-item>
    <van-grid-item>
      <span style="width: 100px">学历证明照片(初中以上)：</span>
      <van-image width="80" height="80" :src="cardUpload.poq[0].content"/>
    </van-grid-item>
    <van-grid-item>
      <span style="width: 100px">电子证件照(本人照片)：</span>
      <van-image
          width="80"
          height="80"
          :src="cardUpload.healthBook[0].content"
      />
    </van-grid-item>
  </van-grid>
  <van-submit-bar
      :price="formData.money * 100"
      button-text="提交订单"
      @submit="onSubmit"
  >
    <template #tip> 请确定信息无误后再提交订单</template>
  </van-submit-bar>
</template>

<script>
import {toRefs} from "vue";
import {Dialog, Toast} from "vant";
import {useRouter} from "vue-router";
import axios, {goRoot} from "../api/http";

export default {
  name: "OrderMinute",
  props: {
    formData: Object,
    cardUpload: Object
  },
  setup(props) {
    console.log(props.formData);
    const router = useRouter();

    function onSubmit() {
      Dialog.confirm({
        title: "提交订单",
        message: "确认提交订单？"
      })
          .then(() => {
            const toast = Toast.loading({
              message: "上传资料中...",
              forbidClick: true,
              loadingType: "spinner",
              duration: 0
            });
            axios
                .post("/api/RegisterInfo/Register", props.formData)
                .then(result => {
                  if (result.data === "null" || result.data === null || result.data === '') {
                    toast.clear();
                    Toast.fail("资料验证失败，请重新进入系统填写资料");
                    goRoot()
                  } else {
                    if (result.data.id !== undefined) {
                      console.log(result.data)
                      console.log(result.data.appId)
                      let params = new FormData();
                      params.append(
                          "fileMore",
                          props.cardUpload.cardPositive[0].file
                      );
                      params.append(
                          "fileMore",
                          props.cardUpload.cardNegative[0].file
                      );
                      if (props.formData.chooseType === '复训') {
                        params.append(
                            "fileMore",
                            props.cardUpload.retrainPositive[0].file
                        );
                        params.append(
                            "fileMore",
                            props.cardUpload.retrainNegative[0].file
                        );
                      }
                      params.append("fileMore", props.cardUpload.poq[0].file);
                      params.append("fileMore", props.cardUpload.healthBook[0].file);
                      params.append("tag", result.data.id);
                      axios
                          .upload("/api/uploadMore", params)
                          .then(() => {
                            toast.clear();
                            if (typeof window.WeixinJSBridge == "undefined") {
                              if (document.addEventListener) {
                                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                              } else if (document.attachEvent) {
                                document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                              }
                            } else {
                              window.WeixinJSBridge.invoke('getBrandWCPayRequest', {
                                    "appId": result.data.appId,
                                    //公众号名称，由商户传入
                                    "timeStamp": result.data.timeStamp,
                                    //时间戳，自1970年以来的秒数
                                    "nonceStr": result.data.nonceStr,
                                    //随机串
                                    "package": result.data.prepayId,
                                    "signType": result.data.signType,
                                    //微信签名方式：
                                    "paySign": result.data.paySign //微信签名
                                  },
                                  function (res) {
                                    if (res.err_msg === "get_brand_wcpay_request:ok") {
                                      axios
                                          .get("/api/RegisterInfo/ChangePayStatus/id/" + result.data.id)
                                          .then(res => {
                                            if (res.data === 'ok') {
                                              router.push({
                                                path: "/paid",
                                                query: {money: props.formData.money}
                                              });
                                            }
                                          });
                                      // 使用以上方式判断前端返回,微信团队郑重提示：
                                      //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                                    } else {
                                      Toast.fail("缴费失败");
                                      goRoot()
                                    }
                                  });
                            }
                            /*               Dialog.alert({
                                             message: "报名成功,请缴费？",
                                             theme: "round-button"
                                           }).then(() => {
                                             router.push({
                                               path: "/paid",
                                               query: {money: props.formData.money}
                                             });
                                           });*/
                          })
                          .catch(e => {
                            console.log(e);
                            toast.clear();
                            Toast.fail("资料验证失败，请重新进入系统填写资料");
                            goRoot()
                          });
                    } else {
                      Toast.fail("资料验证失败，请重新进入系统填写资料");
                      goRoot()
                    }
                  }
                })
                .catch(e => {
                  console.log(e);
                  toast.clear();
                  Toast.fail("保存资料失败,请检测网络环境");
                });
          })
          .catch(() => {
            // on cancel
          });
    }

    function onSubmitO() {
      Dialog.confirm({
        title: "提交订单",
        message: "确认提交订单？"
      })
          .then(() => {
            const toast = Toast.loading({
              message: "上传资料中...",
              forbidClick: true,
              loadingType: "spinner",
              duration: 0
            });
            let params = new FormData();
            params.append(
                "fileMore",
                props.cardUpload.cardPositive[0].file
            );
            params.append(
                "fileMore",
                props.cardUpload.cardNegative[0].file
            );
            if (props.formData.chooseType === '复训') {
              params.append(
                  "fileMore",
                  props.cardUpload.retrainPositive[0].file
              );
              params.append(
                  "fileMore",
                  props.cardUpload.retrainNegative[0].file
              );
            }
            // params.append("fileMore", props.cardUpload.poq[0].file);
            params.append("fileMore", props.cardUpload.healthBook[0].file);
            params.append("tag", 10);
            axios
                .upload("/api/uploadMore", params)
                .then(() => {
                  toast.clear();
                })
                .catch(e => {
                  console.log(e);
                  toast.clear();
                  Toast.fail("资料验证失败，请重新进入系统填写资料");
                  goRoot()
                });

          })
          .catch(() => {
            // on cancel
          });
    }

    function onBridgeReady() {

    }

    return {...toRefs(props), onSubmit, onSubmitO};
  }
};
</script>

<style scoped>
.minute-end {
  margin-bottom: 80px;
}
</style>
